module.exports = __webpack_public_path__ + "static/2c-756f2f075982f025557c0805b9d33f95.png";